import React from 'react';
import { ReactComponent as LinkIcon } from '../../editor/editorFormattingIcons/linkModalIcon.svg';

export const ModalTitle = () => {
  return (
    <div className='d-flex justify-content-between  align-items-center titleText'>
      <LinkIcon className='me-2' />
      Add Link
    </div>
  );
};
